__turbopack_context__.v({
  "root": "ZapsHeader-module__vSsdEG__root",
  "topRow": "ZapsHeader-module__vSsdEG__topRow",
});
